import styledComp from 'styled-components';
// import { default as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { Styling } from '../../../../constants';
import VaultButton from '../../../Shared/VaultButton';

const CONTROL_WIDTH = 140;

export const DateSelectionContainer = styledComp.div`
  margin-top: ${Styling.DEFAULT_SPACING}px;
  margin-right: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  align-items: center;
  display: flex;
`;

export const DatePicker = styledComp(MuiDatePicker)`
  width:${CONTROL_WIDTH}px;

  .MuiInputBase-input {
    font-size: 14px;
  }
`;

export const ControlsSeparator = styledComp.div`
  margin: 0 ${Styling.DEFAULT_SPACING}px;
`;

export const ClearButton = styledComp(VaultButton)`
  margin-left: ${Styling.DEFAULT_SPACING}px;
  width: 105px;
`;

export const SearchButton = styledComp(VaultButton)`
  margin-top: ${Styling.DEFAULT_SPACING}px;
  width: 100px;
`;
